module.exports = __webpack_public_path__ + "static/media/MyProfilePic2.bbee9601.png";